import { render, staticRenderFns } from "./remote-search.vue?vue&type=template&id=74fe1d3e"
import script from "./remote-search.vue?vue&type=script&lang=js"
export * from "./remote-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports